import script from "./PostBody.vue?vue&type=script&lang=ts&setup=true"
export * from "./PostBody.vue?vue&type=script&lang=ts&setup=true"

import "../../assets/css/post-body.css?vue&type=style&index=0&id=2fc8bf37&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc8bf37"]])

export default __exports__